import React from 'react';
import classNames from 'classnames';

interface FieldErrorProps {
  error?: string;
  show: boolean;
}

const FieldError = ({ error, show }: FieldErrorProps) => (
  <div
    className={classNames(
      `absolute bottom-0 left-0 right-0 transition-opacity duration-1500 translate-y-full bg-white/95 text-[10px]
          text-red-light rounded-b-md px-1 py-0.5 text-left z-10`,
      show ? 'opacity-100' : 'opacity-0',
    )}
  >
    {error}
  </div>
);

export default FieldError;
